/* eslint-disable lingui/no-single-tag-to-translate */
// App
import React, { Suspense } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import config from "./config";
import { fetcher, isPartner } from "./components/utility";
import Navbar from "./components/Navbar";
import { connect } from "react-redux";
import { compose } from "redux";
import { setUser, userSetTempHome } from "./actions/user";
import { onMessage, emitMessage } from "./actions/socket";
import { fetchProperties } from "./actions/properties";
import PrivateRoute from "./components/PrivateRoute";
import {
  setHome,
  homeSetSlots,
  homeSetAds,
  homeSetNotifications,
} from "./actions/home";
import { setLoggedIn, setCities } from "./actions/general";
import {
  setConversationPreview,
  addToConversation,
  updatePreview,
  readMessage,
} from "./actions/conversation";
//import { hot } from "react-hot-loader/root";
import { CookieBanner } from "./components/CookieBar/index";
import "./index.css";
import {
  pageViewGA,
  eventGA,
  initGA,
  eventGAWithValue,
  webVitalGA,
} from "./components/TrackerGA";
import reportWebVitals from "./reportWebVitals";
//import yall from "yall-js";
import { Helmet } from "react-helmet";
import Cookies from "js-cookie";
import {
  fbLogIn,
  fbLogInWithCode,
  consumeFacebookOAuthState,
} from "./components/facebookUtility";
import RedirectTo from "./components/RedirectTo";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as Sentry from "@sentry/react";
import setDefaultOptions from "date-fns/setDefaultOptions";
import { it } from "date-fns/locale";
import { theme } from "./theme";
import { t } from "@lingui/macro";
import LocaleChecker from "./components/LocaleChecker";
setDefaultOptions({ locale: it });

const Home = React.lazy(() => import("./pages/Home"));
// const Blog = React.lazy(() => import("./pages/Blog"));
const CreateHome = React.lazy(() => import("./pages/CreateHome"));
const MyProperties = React.lazy(() => import("./pages/MyProperties"));
const CreateHomeStepContacts = React.lazy(() =>
  import("./pages/CreateHomeStepContacts")
);
const HowItWorks = React.lazy(() => import("./pages/HowItWorks"));
const AboutUs = React.lazy(() => import("./pages/AboutUs"));
const WhyCreateHome = React.lazy(() => import("./pages/WhyCreateHome"));
// const WhyUserProfile = React.lazy(() => import("./pages/WhyUserProfile"));
const UserProfile = React.lazy(() => import("./pages/UserProfile"));
const UserProfilation = React.lazy(() => import("./pages/UserProfilation"));
const UserProfilationStepContacts = React.lazy(() =>
  import("./pages/UserProfilationStepContacts")
);

const HomeProfile = React.lazy(() => import("./pages/HomeProfile"));
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy"));
const Terms = React.lazy(() => import("./pages/Terms"));
const CookieTerms = React.lazy(() => import("./pages/CookieTerms"));
const SearchAds = React.lazy(() => import("./pages/SearchAds"));
const SearchTenant = React.lazy(() => import("./pages/SearchTenant"));
const ViewAds = React.lazy(() => import("./pages/ViewAds"));
const ViewUser = React.lazy(() => import("./pages/ViewUser"));
const Notifications = React.lazy(() => import("./pages/Notifications"));
//const Agenda = React.lazy(() => import("./pages/Agenda"));
const HistoryInbox = React.lazy(() => import("./pages/HistoryInbox"));
const Messages = React.lazy(() => import("./pages/Messages"));
// const VideoChat = React.lazy(() => import("./pages/VideoChat"));
const Recover = React.lazy(() => import("./pages/Recover"));
const Settings = React.lazy(() => import("./pages/Settings"));
const VerifyUser = React.lazy(() => import("./pages/VerifyUser"));
const VerifyUserChangeMail = React.lazy(() =>
  import("./pages/VerifyUserChangeMail")
);
const Payments = React.lazy(() => import("./pages/Payments"));

const NoMatch = React.lazy(() => import("./pages/NoMatch"));
const PopupRedirect = React.lazy(() => import("./pages/PopupRedirect"));

const mapDispatchToProps = (dispatch) => {
  return {
    onMessage: (event, handle) => dispatch(onMessage(event, handle)),
    emitMessage: (event, handle) => dispatch(emitMessage(event, handle)),
    setUser: (user) => dispatch(setUser(user)),
    setHome: (home) => dispatch(setHome(home)),
    homeSetSlots: (slots) => dispatch(homeSetSlots(slots)),
    homeSetAds: (advertises) => dispatch(homeSetAds(advertises)),
    homeSetNotifications: (notifications) =>
      dispatch(homeSetNotifications(notifications)),
    setConversationPreview: (previews) =>
      dispatch(setConversationPreview(previews)),
    addToConversation: (conversations) =>
      dispatch(addToConversation(conversations)),
    updatePreview: (conversation, read) =>
      dispatch(updatePreview(conversation, read)),
    readMessage: (conv_id, user_id) => dispatch(readMessage(conv_id, user_id)),
    setLoggedIn: () => dispatch(setLoggedIn()),
    setCities: (cities) => dispatch(setCities(cities)),
    userSetTempHome: (saveObject) => dispatch(userSetTempHome(saveObject)),
  };
};

const mapStateToProps = (state) => {
  return {
    isAuthenticating: state.General.isAuthenticating,
    home_id: state.Home._id,
    newHome: state.Home.new,
    logged: state.User.logged,
    user_id: state.User._id,
    user_city: state.User.city,
    profiled: state.User.profiled,
    seeking: state.User.seeking,
    tempHome: state.User.tempHome,
  };
};

class App extends React.Component {
  constructor(prop) {
    super(prop);
    this.state = {
      buttonRef: null,
      cookieVisible: false,
      cookieStatistics: false,
    };
  }

  LogIn() {
    fetcher({ path: "/api/loggedIn", credentials: true })
      .then((res) => {
        if (!res.success) {
          Sentry.captureException(res);
        } else {
          res.user.logged = true;
          res.user.tenants.forEach((tenant, index) => {
            if (tenant.user_id) {
              let user_tenant = res.user_tenants.find(
                (x) => x._id == tenant.user_id
              );
              if (user_tenant) {
                let pickedUser = {};
                pickedUser.value = user_tenant._id;
                pickedUser.image = user_tenant.profile_image;
                pickedUser.image_webp = user_tenant.profile_image_webp;
                pickedUser.location = user_tenant.location;
                pickedUser.age = user_tenant.age;
                pickedUser.type = user_tenant.type;
                pickedUser.label = user_tenant.name + " " + user_tenant.surname;
                res.user.tenants[index].pickedUser = pickedUser;
                res.user.tenants[index].image = user_tenant.profile_image;
                res.user.tenants[index].image_webp =
                  user_tenant.profile_image_webp;
              }
            }
          });
          try {
            if (res.conversations != null) {
              this.props.setConversationPreview(res.conversations);
            }
          } catch (error) {
            Sentry.captureException(error);
          }
          this.props.setUser(res.user);
          this.setState({ user_id: res.user._id });
          if (res.home != null) {
            res.home.tenants.forEach((tenant, i_t) => {
              if (tenant.user_id) {
                let home_tenant = res.home_tenants.find(
                  (x) => x._id == tenant.user_id
                );
                if (home_tenant) {
                  let pickedUser = {};
                  pickedUser.value = home_tenant._id;
                  pickedUser.image = home_tenant.profile_image;
                  pickedUser.image_webp = home_tenant.profile_image_webp;
                  pickedUser.location = home_tenant.location;
                  pickedUser.age = home_tenant.age;
                  pickedUser.type = home_tenant.type;
                  pickedUser.label =
                    home_tenant.name + " " + home_tenant.surname;
                  res.home.tenants[i_t].pickedUser = pickedUser;
                  res.home.tenants[i_t].image = home_tenant.profile_image;
                  res.home.tenants[i_t].image_webp =
                    home_tenant.profile_image_webp;
                }
              }
            });
            if (res.ads != null) {
              res.home.advertises = res.ads;
            }
            this.props.setHome(res.home);

            if (res.slotArray != null) {
              this.props.homeSetSlots(res.slotArray);
            }
            // Multi-home: load the property list so the navbar/hub know the
            // count (drives the smart home link + the switcher visibility).
            if (config.multiHome) fetchProperties();
          }
          if (res.home != null) {
            this.props.emitMessage("login_home", res.home._id);
            this.props.emitMessage("login_user", res.user._id);
          } else this.props.emitMessage("login_user", res.user._id);
        }
        if (res.notifications != null) {
          this.props.homeSetNotifications(res.notifications);
        }
      })
      .then((/*res*/) => {
        this.props.setLoggedIn();
      })
      .catch((e) => Sentry.captureException(e));
  }

  checkProfiledUser() {
    const { logged, profiled, seeking, home_id, location } = this.props;
    const { pathname } = location;

    if (!logged) return;

    // Public/legal/informational pages — never redirect away from these,
    // even if the user is mid-onboarding. They must be reachable from the
    // signup modal links and from anywhere else.
    const informationalPaths = [
      "privacy-policy",
      "terms",
      "cookie-terms",
      "about-us",
      "come-funziona",
      "pricing",
    ];
    if (informationalPaths.some((p) => pathname.includes(p))) return;

    // Seeker not yet profiled → go to profile completion.
    // Skip when user is editing their profile (user-profile) — those edits
    // shouldn't push them back into the onboarding multistep — and when they
    // are in the publish-a-listing funnel (same exclusions as the safety net
    // below): finishing it sets seeking=false, so don't yank them out of it.
    if (
      !profiled &&
      seeking &&
      !pathname.includes("completa-profilo") &&
      !pathname.includes("pubblica-annuncio") &&
      !pathname.includes("why-create-home") &&
      !pathname.includes("user-profile")
    ) {
      this.props.history.push("/completa-profilo");
      return;
    }

    // Safety net: no profile, no listing, no seeking intent, not in any onboarding flow.
    // A half-built tempHome means they were in the publish funnel (landlord) —
    // resume the wizard; otherwise assume seeker and go to profilation.
    if (
      !profiled &&
      !seeking &&
      home_id === -1 &&
      !pathname.includes("completa-profilo") &&
      !pathname.includes("pubblica-annuncio") &&
      !pathname.includes("why-create-home") &&
      !pathname.includes("user-profile")
    ) {
      const hasDraftHome =
        this.props.tempHome && Object.keys(this.props.tempHome).length > 0;
      this.props.history.push(
        hasDraftHome
          ? "/pubblica-annuncio-stanza-appartamento"
          : "/completa-profilo"
      );
    }
  }

  loadCities = async () => {
    try {
      const res = await fetcher({
        path: "/api/getCities",
        method: "GET",
      });
      this.props.setCities(res.cities);
    } catch (e) {
      console.error("Error during Fetch:", e);
      Sentry.captureException(e);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.location.pathname !== this.props.location.pathname ||
      prevProps.logged !== this.props.logged ||
      prevProps.seeking !== this.props.seeking ||
      prevProps.home_id !== this.props.home_id
    ) {
      this.checkProfiledUser();
    }
    if (prevState.cookieStatistics !== this.state.cookieStatistics) {
      initGA("UA-158520293-1", "trackerApp", this.state.cookieStatistics);

      pageViewGA();

      reportWebVitals(({ name, delta, id }) => {
        webVitalGA(
          // eslint-disable-next-line lingui/no-unlocalized-strings
          "Web Vitals",
          name,
          id,
          Math.round(name === "CLS" ? delta * 1000 : delta)
        );
      });

      eventGA(
        "NAVIGAZIONE",
        window.location.pathname + window.location.search,
        this.props.user_id > 0 ? "User_" + this.props.user_id : "New_User",
        this.props.user_city
      );

      this.unlisten = this.props.history.listen((/*location, action*/) => {
        //pageViewGA();
        eventGA(
          "NAVIGAZIONE",
          window.location.pathname + window.location.search,
          this.props.user_id > 0 ? "User_" + this.props.user_id : "New_User",
          this.props.user_city
        );
      });
    }
  }

  componentDidMount() {
    if (!Cookies.get("_ga")) {
      initGA("UA-158520293-1", "trackerApp", false);
    } else {
      initGA("UA-158520293-1", "trackerApp", true);

      pageViewGA();

      reportWebVitals(({ name, delta, id }) => {
        eventGAWithValue(
          // eslint-disable-next-line lingui/no-unlocalized-strings
          "Web Vitals",
          name,
          id,
          Math.round(name === "CLS" ? delta * 1000 : delta)
        );
      });

      eventGA(
        "NAVIGAZIONE",
        window.location.pathname + window.location.search,
        this.props.user_id > 0 ? "User_" + this.props.user_id : "New_User",
        this.props.user_city
      );

      this.unlisten = this.props.history.listen((/*location, action*/) => {
        pageViewGA();
        eventGA(
          "NAVIGAZIONE",
          window.location.pathname + window.location.search,
          this.props.user_id > 0 ? "User_" + this.props.user_id : "New_User",
          this.props.user_city
        );
      });
    }

    setTimeout(() => this.setState({ cookieVisible: true }), 1500);

    this.props.onMount();

    this.checkProfiledUser();

    this.loadCities();

    if (window.location.hash) {
      var params = window.location.hash.substr(1).split("&");

      for (var i = 0; i < params.length; i++) {
        var a = params[i].split("=");
        // Now every parameter from the hash is beind handled this way
        if (a[0] === "access_token") {
          this.props.history.push({ search: "" });
          fbLogIn(a[1]);
        } else if (a[0] === "cmp") {
          const campaign = a[1];
          this.props.userSetTempHome({ campaign: campaign });
          this.tempSave({ ...this.props.tempHome, campaign: campaign });
          eventGA(
            "CAMPAIGN",
            campaign,
            this.props.user_id > 0 ? "User_" + this.props.user_id : "New_User",
            this.props.user_city
          );
          window.location.hash = "";
        }
      }
    }

    // Facebook OAuth code-flow return: ?code=...&state=...
    if (window.location.search.includes("code=")) {
      const searchParams = new URLSearchParams(window.location.search);
      const code = searchParams.get("code");
      const returnedState = searchParams.get("state");
      if (code) {
        const { state: savedState, redirectUri } = consumeFacebookOAuthState();
        // CSRF check: if we have a saved state, require an exact match.
        // If sessionStorage was unavailable (private mode etc.), we accept
        // the code without state — same trust boundary as the prior token flow.
        const stateValid = !savedState || returnedState === savedState;
        if (stateValid) {
          this.props.history.replace({ search: "" });
          fbLogInWithCode(
            code,
            redirectUri || window.location.origin + "/"
          );
        }
      }
    }

    //Lazy Loading
    //document.addEventListener("DOMContentLoaded", yall);

    this.LogIn();
    // eslint-disable-next-line lingui/no-unlocalized-strings
    this.props.onMessage("New_message", (conv) => {
      if (window.location.pathname != "/messages") {
        this.props.addToConversation(conv);
        this.props.updatePreview(conv[0]);
      } else {
        let params = new URLSearchParams(window.location.search);
        if (params.has("a")) {
          if (
            window.location.pathname == "/messages" &&
            params.get("a") != conv[0].conversation_id
          ) {
            this.props.updatePreview(conv[0]);
          }
        }
      }
    });
    // eslint-disable-next-line lingui/no-unlocalized-strings
    this.props.onMessage("Read_message", (reader) => {
      if (window.location.pathname != "/messages") {
        this.props.readMessage(reader.conv_id, reader.user_id);
      }
    });
    // eslint-disable-next-line lingui/no-unlocalized-strings
    this.props.onMessage("New_conversation", (conv) => {
      this.props.setConversationPreview(conv);
    });
  }

  componentWillUnmount() {
    this.unlisten?.();
  }

  onRefChange = (node) => {
    this.setState({ buttonRef: node });
  };

  tempSave = (saveObject) => {
    localStorage.setItem(
      "tempHome",
      JSON.stringify(saveObject || this.props.tempHome)
    );
  };

  render() {
    const {
      home_id,
      newHome,
      subscribed,
      subscribedBasic,
      logged,
      isAuthenticating,
      profiled,
      seeking,
    } = this.props;
    return (
      <div>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <Helmet>
                <meta charSet="utf-8" />
                <meta
                  name="description"
                  content="Trova su Thipibo la tua nuova casa, appartamento o stanza in affitto. Oppure cerca l'inquilino ideale, tanti studenti e lavoratori fuorisede si sono già iscritti."
                />
                {/* Helmet only registers plain head tags as children — a
                    <Trans>-wrapped <title> is silently ignored, leaving no
                    default title to restore when a page (e.g. ViewAds) that
                    set its own unmounts. Use the t macro instead. */}
                <title>
                  {t`Thipibo - Cerca stanze, appartamenti in affitto e coinquilini`}
                </title>
              </Helmet>
              <Navbar buttonRef={this.state.buttonRef} />
              <Suspense fallback={null}>
                {/* {!isPartner() ? ( */}
                <Switch>
                  <Route exact path="/:lang/" component={Home} />
                  <Route
                    restricted={home_id === -1}
                    isAuthenticating={isAuthenticating}
                    path="/:lang/pubblica-annuncio-stanza-appartamento/contatti"
                    // redirect="/pubblica-annuncio-stanza-appartamento"
                    component={CreateHomeStepContacts}
                  />
                  <PrivateRoute
                    restricted={home_id !== -1 && !newHome}
                    isAuthenticating={isAuthenticating}
                    path="/:lang/pubblica-annuncio-stanza-appartamento"
                    redirect="/home-profile"
                    component={CreateHome}
                  />
                  <PrivateRoute
                    restricted={!logged}
                    isAuthenticating={isAuthenticating}
                    path="/:lang/completa-profilo/contatti"
                    redirect="/:lang/"
                    component={UserProfilationStepContacts}
                  />
                  <PrivateRoute
                    restricted={!logged}
                    isAuthenticating={isAuthenticating}
                    path="/:lang/completa-profilo"
                    redirect="/:lang/"
                    component={UserProfilation}
                  />
                  <PrivateRoute
                    restricted={!logged}
                    isAuthenticating={isAuthenticating}
                    path="/:lang/user-profile"
                    component={UserProfile}
                  />
                  <PrivateRoute
                    restricted={home_id === -1}
                    isAuthenticating={isAuthenticating}
                    path="/:lang/home-profile"
                    component={HomeProfile}
                  />
                  {/* Multi-home: properties hub. Needs at least one home.
                      Flag-gated so the feature is unreachable (even by direct
                      URL) until VITE_MULTI_HOME is enabled. */}
                  {config.multiHome && (
                    <PrivateRoute
                      restricted={home_id === -1}
                      isAuthenticating={isAuthenticating}
                      path="/:lang/le-mie-proprieta"
                      redirect="/pubblica-annuncio-stanza-appartamento"
                      component={MyProperties}
                    />
                  )}
                  {/* Multi-home: add another property — reuses the create-home
                      multistep, gated only by login (bypasses the single-home
                      restriction so existing owners can append). */}
                  {config.multiHome && (
                    <PrivateRoute
                      restricted={!logged}
                      isAuthenticating={isAuthenticating}
                      path="/:lang/aggiungi-proprieta"
                      redirect="/:lang/"
                      component={CreateHome}
                    />
                  )}
                  <Route
                    path="/:lang/cerca-annunci-stanza-appartamento/:city"
                    render={(props) => (
                      <RedirectTo {...props} url="/:lang/affitto/:city" />
                    )}
                  />
                  <Route
                    path="/:lang/cerca-casa-stanza/:city"
                    render={(props) => (
                      <RedirectTo {...props} url="/:lang/affitto/:city" />
                    )}
                  />
                  <Route path="/:lang/affitto/:city" component={SearchAds} />
                  <Route
                    path="/:lang/cerca-inquilino/:city"
                    component={SearchTenant}
                  />
                  <Route
                    path="/:lang/stanza/:advertiseId"
                    component={ViewAds}
                  />
                  <Route
                    path="/:lang/inquilino/:profileId"
                    component={ViewUser}
                  />
                  <Route
                    path="/:lang/privacy-policy"
                    component={PrivacyPolicy}
                  />
                  <Route path="/:lang/cookie-terms" component={CookieTerms} />
                  <Route path="/:lang/terms" component={Terms} />
                  <Route
                    path="/:lang/why-create-home"
                    render={(props) => (
                      <WhyCreateHome
                        {...props}
                        refProp={this.state.buttonRef}
                        buttonRef={this.onRefChange}
                      />
                    )}
                  />
                  <Route path="/:lang/come-funziona" component={HowItWorks} />
                  <Route path="/:lang/about-us" component={AboutUs} />
                  <PrivateRoute
                    restricted={!logged}
                    isAuthenticating={isAuthenticating}
                    path="/:lang/notifications"
                    component={Notifications}
                  />
                  <PrivateRoute
                    restricted={!logged}
                    isAuthenticating={isAuthenticating}
                    path="/:lang/inbox"
                    component={HistoryInbox}
                  />
                  <PrivateRoute
                    restricted={!logged}
                    isAuthenticating={isAuthenticating}
                    path="/:lang/messages"
                    component={Messages}
                  />
                  <PrivateRoute
                    restricted={!logged}
                    isAuthenticating={isAuthenticating}
                    path="/:lang/settings"
                    component={Settings}
                  />
                  <Route path="/:lang/recover" component={Recover} />
                  <Route path="/:lang/verifyUser" component={VerifyUser} />
                  <PrivateRoute
                    restricted={subscribed || subscribedBasic}
                    isAuthenticating={isAuthenticating}
                    path="/:lang/pricing"
                    component={Payments}
                  />
                  <Route
                    path="/:lang/ChangeMail"
                    component={VerifyUserChangeMail}
                  />
                  <Route
                    path="/:lang/popup-redirect"
                    component={PopupRedirect}
                  />
                  <Route path="*" component={NoMatch} />
                </Switch>
                {/* ) : (
                  <Switch>
                    <Route exact path="/" component={SearchTenant} />
                    <Route path="/inquilino/:profileId" component={ViewUser} />
                    <Route path="/privacy-policy" component={PrivacyPolicy} />
                    <Route path="/cookie-terms" component={CookieTerms} />
                    <Route path="/terms" component={Terms} />
                    <PrivateRoute
                      restricted={!logged}
                      isAuthenticating={isAuthenticating}
                      path="/completa-profilo/contatti"
                      redirect="/"
                      component={UserProfilationStepContacts}
                    />
                    <PrivateRoute
                      restricted={!logged}
                      isAuthenticating={isAuthenticating}
                      path="/completa-profilo"
                      redirect="/"
                      component={UserProfilation}
                    />
                    <PrivateRoute
                      restricted={!logged}
                      isAuthenticating={isAuthenticating}
                      path="/user-profile"
                      component={UserProfile}
                    />
                    <PrivateRoute
                      restricted={!logged}
                      isAuthenticating={isAuthenticating}
                      path="/notifications"
                      component={Notifications}
                    />
                    <PrivateRoute
                      restricted={!logged}
                      isAuthenticating={isAuthenticating}
                      path="/inbox"
                      component={HistoryInbox}
                    />
                    <PrivateRoute
                      restricted={!logged}
                      isAuthenticating={isAuthenticating}
                      path="/messages"
                      component={Messages}
                    />
                    <PrivateRoute
                      restricted={!logged}
                      isAuthenticating={isAuthenticating}
                      path="/settings"
                      component={Settings}
                    />
                    <Route path="/recover" component={Recover} />
                    <Route path="/verifyUser" component={VerifyUser} />
                    <PrivateRoute
                      restricted={subscribed || subscribedBasic}
                      isAuthenticating={isAuthenticating}
                      path="/pricing"
                      component={Payments}
                    />
                    <Route
                      path="/ChangeMail"
                      component={VerifyUserChangeMail}
                    />
                    <Route path="/popup-redirect" component={PopupRedirect} />
                    <Route path="/:city" component={SearchTenant} />
                  </Switch>
                )} */}
              </Suspense>
              <LocaleChecker />
              {this.state.cookieVisible && (
                <>
                  <div className="d-flex d-md-none">
                    <CookieBanner
                      message={t`Hai fame? Prendi un biscotto! Utilizziamo i cookie per offrirti la migliore esperienza
                possibile.`}
                      policyLink="/cookie-terms"
                      privacyPolicyLinkText={t`Utilizzo dei Cookie`}
                      necessaryOptionText={t`Necessari`}
                      preferencesOptionText={t`Preferenze`}
                      statisticsOptionText={t`Statistiche`}
                      marketingOptionText={t`Marketing`}
                      acceptButtonText={t`Accetta`}
                      declineButtonText={t`Rifiuta`}
                      managePreferencesButtonText={t`Gestisci preferenze`}
                      savePreferencesButtonText={t`Salva preferenze`}
                      showDeclineButton={false}
                      onAcceptStatistics={() => {
                        if (!this.state.cookieStatistics) {
                          this.setState({ cookieStatistics: true });
                        }
                      }}
                      styles={{
                        container: { maxWidth: "none" },
                        dialog: {
                          position: "fixed",
                          bottom: "0",
                          left: "0",
                          right: "0",
                          zIndex: "100000",
                          color: "white",
                          fontWeight: "400",
                          borderRadius: "5px",
                          // eslint-disable-next-line lingui/no-unlocalized-strings
                          backgroundColor: "rgba(94, 94, 94, 0.75)",
                          padding: "10px",
                          marginBottom:
                            // eslint-disable-next-line lingui/no-unlocalized-strings
                            "calc(3em + env(safe-area-inset-bottom))",
                        },
                        message: {
                          color: "white",
                        },
                        policy: {
                          color: "white",
                          textDecoration: "underline",
                          fontWeight: "300",
                        },
                        button: {
                          backgroundColor: "#FF7417",
                          //  fontSize: "13px",
                          color: "white",
                          borderRadius: "5px",
                          marginColor: "#FF7417",
                          border: "solid",
                          borderColor: "#FF7417",
                          margin: "10px",
                        },
                        secondaryButton: {
                          // eslint-disable-next-line lingui/no-unlocalized-strings
                          backgroundColor: "rgba(94, 94, 94, 0.75)",
                          color: "white",
                          borderRadius: "5px",
                          border: "solid",
                          borderColor: "white",
                          margin: "10px",
                        },
                      }}
                    />
                  </div>
                  <div className="d-none d-md-flex">
                    <CookieBanner
                      message={t`Hai fame? Prendi un biscotto! Utilizziamo i cookie per offrirti la migliore esperienza
                possibile.`}
                      policyLink="/cookie-terms"
                      privacyPolicyLinkText={t`Utilizzo dei Cookie`}
                      necessaryOptionText={t`Necessari`}
                      preferencesOptionText={t`Preferenze`}
                      statisticsOptionText={t`Statistiche`}
                      marketingOptionText={t`Marketing`}
                      acceptButtonText={t`Accetta`}
                      declineButtonText={t`Rifiuta`}
                      managePreferencesButtonText={t`Gestisci preferenze`}
                      savePreferencesButtonText={t`Salva preferenze`}
                      showDeclineButton={false}
                      onAcceptStatistics={() => {
                        if (!this.state.cookieStatistics) {
                          this.setState({ cookieStatistics: true });
                        }
                      }}
                      styles={{
                        container: { maxWidth: "none" },
                        dialog: {
                          position: "fixed",
                          bottom: "0",
                          left: "0",
                          right: "0",
                          zIndex: "100000",
                          color: "white",
                          fontWeight: "400",
                          borderRadius: "5px",
                          // eslint-disable-next-line lingui/no-unlocalized-strings
                          backgroundColor: "rgba(94, 94, 94, 0.75)",
                          padding: "10px",
                        },
                        message: {
                          color: "white",
                        },
                        policy: {
                          color: "white",
                          textDecoration: "underline",
                          fontWeight: "300",
                        },
                        button: {
                          backgroundColor: "#FF7417",
                          //  fontSize: "13px",
                          color: "white",
                          borderRadius: "5px",
                          marginColor: "#FF7417",
                          border: "solid",
                          borderColor: "#FF7417",
                          margin: "10px",
                        },
                        secondaryButton: {
                          // eslint-disable-next-line lingui/no-unlocalized-strings
                          backgroundColor: "rgba(94, 94, 94, 0.75)",
                          color: "white",
                          borderRadius: "5px",
                          border: "solid",
                          borderColor: "white",
                          margin: "10px",
                        },
                      }}
                    />
                  </div>
                </>
              )}
            </ThemeProvider>
          </StyledEngineProvider>
        </LocalizationProvider>
      </div>
    );
  }
}
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(App);
